/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoriesResponse } from '../../models/company-categories-response';
import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';

export interface GetCompanyCategoriesByCompanySearchFilters$Params {
      body: GetCompaniesNearMeRequest
}

export function getCompanyCategoriesByCompanySearchFilters(http: HttpClient, rootUrl: string, params: GetCompanyCategoriesByCompanySearchFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoriesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyCategoriesByCompanySearchFilters.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCategoriesResponse>>;
    })
  );
}

getCompanyCategoriesByCompanySearchFilters.PATH = '/api/company-categories-by-company-search-filters';
